import { GraphqlContextValues } from '@sbu/contexts.graphql';

import { SearchResultType } from 'core/graphql';

import { FieldTypes, numericFieldDefaults } from '../types';
import {
  globalOperators,
  stringOperators,
  textOperators,
} from '../types/operatorTypes';
import { autocompleteQuery } from './gql';
import { normalizedObjectTypes } from './record';

const source = 'mapping';

export const getMappingFields = (
  graphqlContext: GraphqlContextValues
): FieldTypes[] => [
  {
    label: 'Name',
    prop: 'name',
    query: (value) =>
      autocompleteQuery(
        SearchResultType.Mappings,
        'name',
        value,
        graphqlContext
      ),
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Object Type',
    prop: 'recordType',
    operators: [...globalOperators],
    type: 'list',
    source,
    options: normalizedObjectTypes,
  },
  {
    label: 'Output Vendor',
    prop: 'vendor',
    query: (value) =>
      autocompleteQuery(
        SearchResultType.Mappings,
        'vendor',
        value,
        graphqlContext
      ),
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Output Product',
    prop: 'product',
    query: (value) =>
      autocompleteQuery(
        SearchResultType.Mappings,
        'product',
        value,
        graphqlContext
      ),
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Format',
    prop: 'logFormat',
    operators: [...globalOperators],
    type: 'list',
    source,
    options: [
      {
        label: 'CEF',
        prop: 'CEF',
      },
      {
        label: 'JSON',
        prop: 'JSON',
      },
      {
        label: 'LEEF',
        prop: 'LEEF',
      },
      {
        label: 'SYSLOG',
        prop: 'SYSLOG',
      },
      {
        label: 'WINDOWS',
        prop: 'WINDOWS',
      },
    ],
  },
  {
    label: 'Structured',
    prop: 'isStructured',
    operators: [...globalOperators],
    type: 'list',
    source,
    options: [
      {
        label: 'Structured',
        prop: 'true',
      },
      {
        label: 'Unstructured',
        prop: 'false',
      },
    ],
  },
  {
    label: 'Event ID Pattern',
    prop: 'eventIdPattern',
    query: (value) =>
      autocompleteQuery(
        SearchResultType.Mappings,
        'eventIdPattern',
        value,
        graphqlContext
      ),
    operators: [...globalOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Grok Pattern',
    prop: 'patternName',
    query: (value) =>
      autocompleteQuery(
        SearchResultType.Mappings,
        'patternName',
        value,
        graphqlContext
      ),
    operators: [...globalOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Custom',
    prop: 'isCustom',
    operators: [...globalOperators],
    type: 'list',
    source,
    options: [
      {
        label: 'Custom',
        prop: 'true',
      },
      {
        label: 'Default',
        prop: 'false',
      },
    ],
  },
  {
    label: 'Status',
    prop: 'enabled',
    operators: [...globalOperators],
    type: 'list',
    source,
    options: [
      {
        label: 'Enabled',
        prop: 'true',
      },
      {
        label: 'Disabled',
        prop: 'false',
      },
    ],
  },
  {
    ...numericFieldDefaults,
    source,
    label: 'Record Count Past 7 Days',
    prop: 'recordCount07D',
    min: 0,
  },
  {
    ...numericFieldDefaults,
    source,
    label: 'Record Count Past 24 Hours',
    prop: 'recordCount24H',
    min: 0,
  },
];
